import { useEffect } from "react";
import { useParams } from "react-router";

const useSetTags = (config) => {

    const { lang } = useParams()
    useEffect(() => {
        document.title = config[lang]?.title;
        
        if (config[lang]?.description) {
            document.getElementsByName('description')[0].content =
                config[lang]?.description;
        }
    }, [lang])
}

export default useSetTags;